// extracted by mini-css-extract-plugin
export default {"section-title":"ListingBodySection-module__section-title--qzlJw"};